import { FinchProviderKey } from '@common/neo.tax';

import { FINCH_PROVIDERS } from './finch.constants';
import { FinchProvider } from './finch.types';

export const getFinchProviderKey = (provider: FinchProvider): FinchProviderKey => {
  const providerKey = FINCH_PROVIDERS[provider];
  return providerKey;
};

export const isFinchProvider = (provider: string): provider is FinchProvider =>
  Object.keys(FINCH_PROVIDERS).includes(provider);
